import AddPassengerModal from "./AddPassengerModal";

export default AddPassengerModal;